import { BaseAddress } from "../../fay/generated/api";

export type UserType = "Patient" | "Provider";

const userTypeMap: Record<string, UserType> = {
  client: "Patient",
  provider: "Provider",
};

export const currentUserType: UserType | undefined =
  userTypeMap[process.env.REACT_APP_FAY_APP!];

if (!currentUserType) {
  throw new Error(`Invalid app deployment: ${process.env.REACT_APP_FAY_APP}`);
}

export const formatAddress = (address: BaseAddress) => {
  const streetAddress = address.line2
    ? `${address.line1}, ${address.line2}`
    : address.line1;
  return `${streetAddress}, ${address.city}, ${address.state} ${address.postal_code}`;
};

export const simpleHash = (str: string): number => {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i); // bitwise XOR for variety
  }
  return hash >>> 0; // force unsigned 32-bit integer
};

export const simpleHashHex = (str: string): string => {
  return simpleHash(str).toString(16).padStart(8, "0"); // convert to hex and pad with zeros
};
